import { xBaseTheme } from "@monsma/XDL/types";

export default {} as xBaseTheme;
